export default __webpack_public_path__ + "assets/elichens-icon-colored-white-e.84e59ca4.svg";